export default __webpack_public_path__ + "static/media/lds-logo_fr.818c423bddfa0d17.svg";